module.exports = __webpack_public_path__ + "media/application/images/kids/link-card-a1d82aa14b8d13b143e2c490015c33d3.png";